export const PDF_RENDERED_EXTENSIONS = ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'potx', 'key'];

export const isPdfRenderedExtension = (ext: string) => PDF_RENDERED_EXTENSIONS.includes(ext.toLowerCase());

export const isPdfExtension = (ext?: string | null) => ext?.toLowerCase() === 'pdf';
